export default {"src":"/_next/static/media/Capital-providers.fa28cd1b.svg","height":1600,"width":1600};